import { render, staticRenderFns } from "./EditPaapCentralization.vue?vue&type=template&id=0fc1bf8b"
import script from "./EditPaapCentralization.vue?vue&type=script&lang=js"
export * from "./EditPaapCentralization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports